export default "/images/5b8c0ad20d65992458e6186ee2408ab9.avif";